(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scratch-card-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COOKIE_NAME = 'beimli_scratch_seen';
  var COOKIE_DAYS = 30;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
  }

  if (getCookie(COOKIE_NAME)) return;

  var overlay = document.getElementById('beimli-scratch-popup');
  if (!overlay) return;
  if (overlay.dataset.hide === 'true') return;

  var shown = false;

  function showPopup() {
    if (shown) return;
    shown = true;
    overlay.style.display = 'flex';
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
  }

  function closePopup() {
    overlay.style.display = 'none';
  }

  document.getElementById('beimliScratchClose').addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  var isMobile = window.matchMedia('(pointer: coarse)').matches;

  if (isMobile) {
    setTimeout(showPopup, 15000);
  } else {
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY < 10) {
        showPopup();
      }
    });
  }

  var formStep = document.getElementById('beimliScratchFormStep');
  var cardStep = document.getElementById('beimliScratchCardStep');
  var form = document.getElementById('beimli-scratch-form');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var errorEl = form.querySelector('.beimli-scratch-error');
      if (errorEl) errorEl.style.display = 'none';

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data && data.errors) {
            if (errorEl) errorEl.style.display = 'block';
            return;
          }
          formStep.style.display = 'none';
          cardStep.style.display = 'block';
          initScratchCard();
        })
        .catch(function () {
          formStep.style.display = 'none';
          cardStep.style.display = 'block';
          initScratchCard();
        });
    });
  }

  function initScratchCard() {
    var canvas = document.getElementById('beimliScratchCanvas');
    if (!canvas || canvas.dataset.initialized) return;
    canvas.dataset.initialized = 'true';

    var ctx = canvas.getContext('2d');
    ctx.fillStyle = '#c9bd98';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.font = '12px sans-serif';
    ctx.fillStyle = 'rgba(26,71,92,0.35)';
    for (var i = 0; i < 40; i++) {
      ctx.fillText('SCRATCH', Math.random() * 300, Math.random() * 130);
    }

    var isDown = false;
    var revealed = false;

    function getPos(e) {
      var rect = canvas.getBoundingClientRect();
      var scaleX = canvas.width / rect.width;
      var scaleY = canvas.height / rect.height;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      var clientY = e.touches ? e.touches[0].clientY : e.clientY;
      return { x: (clientX - rect.left) * scaleX, y: (clientY - rect.top) * scaleY };
    }

    function scratch(x, y) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, 18, 0, Math.PI * 2);
      ctx.fill();
      checkRevealPercent();
    }

    function checkRevealPercent() {
      if (revealed) return;
      var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var transparent = 0;
      for (var i = 3; i < imageData.length; i += 4 * 20) {
        if (imageData[i] === 0) transparent++;
      }
      var total = imageData.length / (4 * 20);
      if (transparent / total > 0.45) {
        revealed = true;
        document.getElementById('beimliScratchHint').style.display = 'none';
        document.getElementById('beimliScratchReveal').style.display = 'block';
        canvas.style.opacity = '0';
        canvas.style.transition = 'opacity 0.4s';
      }
    }

    canvas.addEventListener('mousedown', function (e) { isDown = true; var p = getPos(e); scratch(p.x, p.y); });
    canvas.addEventListener('mousemove', function (e) { if (isDown) { var p = getPos(e); scratch(p.x, p.y); } });
    window.addEventListener('mouseup', function () { isDown = false; });
    canvas.addEventListener('touchstart', function (e) { isDown = true; var p = getPos(e); scratch(p.x, p.y); });
    canvas.addEventListener('touchmove', function (e) { e.preventDefault(); var p = getPos(e); scratch(p.x, p.y); });
    canvas.addEventListener('touchend', function () { isDown = false; });
  }

  var copyBtn = document.getElementById('beimliScratchCopy');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText('IMLI10').then(function () {
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 2000);
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
